//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { store } from "./store"
import PanelHomeGroup from './PanelHomeGroup.vue'
import PanelStoryGroup from './PanelStoryGroup.vue'
import PanelPresetGroup from './PanelPresetGroup.vue'

let initialStoriesData = JSON.parse(window.__INITIAL_STATE_STORIES__) || {};
let initialPresetsData = JSON.parse(window.__INITIAL_STATE_PRESETS__) || {};

store.initialStoriesData = initialStoriesData
store.initialPresetsData = initialPresetsData

export default {
  name: 'PanelHome',
  components: {
    PanelHomeGroup,
    PanelStoryGroup,
    PanelPresetGroup,
  },
  data() {
    return {
      pages: [],
      isOpen: null,
      stories: initialStoriesData,
      presets: initialPresetsData,
    }
  },
  mounted() {
    fetch('/wp-json/wp/v2/pages?orderby=meta_value_num&meta_key=_mapping_page_volgorde&order=asc&_fields[]=title&_fields[]=content')
    .then(response => response.json())
    .then(json => this.pages = json)
  },
  methods: {
    toggleHeader(index) {
      // click on open item should close it
      if(this.isOpen === index) {
        this.isOpen = null
      } else {
        this.isOpen = index
      }
    },
  },
}



// WEBPACK FOOTER //
// ./scripts/vue/PanelHome.vue